<template>
    <div>
    </div>
</template>


<script>
    import {get} from '../util/util'
    import { Dialog } from 'vant';
    import 'vant/lib/dialog/style';
    import { Loading } from 'vant';
    import 'vant/lib/loading/style';


   export default{
        data(){
            return{
              authForm:{
                authCode:'',//微信支付宝的openid
                payType:0,//0、微信  1、支付宝
                shortParam:''
              },

              redirectUri: encodeURIComponent('https://pay.yundiankong.com'),
              wxForm:{
                appId: 'wx1e95256a06889ca0',
                scope: 'snsapi_base',
              },
              
              aliForm:{
                appId: '2021006137662674',
                scope: 'auth_base',
              }

            }
        },
        components: {
			[Loading.name]: Loading,
        },
        created(){
            this.authForm.payType=-1
            const ua = navigator.userAgent.toLowerCase();
            if (/micromessenger/i.test(ua)) {
                this.authForm.payType=0
            }
            if (/alipayclient/i.test(ua)) {
                this.authForm.payType=1
            }
            if(this.authForm.payType===-1){
                Dialog({ message: '请使用微信或支付宝扫码'});
                return 
            }

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this.authForm.shortParam = urlParams.get('id');

            window.sessionStorage.setItem("ca_pay_authForm",JSON.stringify(this.authForm))

            //获取授权码
            const state = Date.now().toString() // 防止csrf攻击

            let authUrl=''
            if(this.authForm.payType===0){
                authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxForm.appId}&redirect_uri=${this.redirectUri}&response_type=code&scope=${this.wxForm.scope}&state=${state}#wechat_redirect`
            }
            if(this.authForm.payType===1){
                authUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${this.aliForm.appId}&scope=${this.aliForm.scope}&redirect_uri=${this.redirectUri}`
            }
            window.location.href = authUrl
        },
        methods:{


        }
    }
</script>


<style></style>